import React, { useEffect } from "react"
import { Row, Col, Dropdown } from "react-bootstrap"
import * as Yup from "yup"
import { Formik, Form as FormikForm, Field } from "formik"
import { useDispatch, useSelector, shallowEqual, batch } from "react-redux"
import {
  updateValidFormData,
  updateUiData,
  selectDocument,
  updateDropdown,
  updateDocumentMandatory,
  updateDocumentVisible,
  updateClaimData,
  resetPetLossDetail,
} from "../redux/actions"
import * as Constants from "../common/constants"
import FormLabel from "../components/shared/formLabel"
import Dropzone from "../components/dropzone"
import { backMaxPage } from "../common/function"
import Declaration from "../components/declaration"
import FormDropdownArray from "../components/shared/formDropdownArray"
import FormTextbox from "../components/shared/formTextbox"
import FormAmountTextBox from "../components/shared/formAmountTextBox"
import FormDateInputTextbox from "../components/shared/formDateInputTextbox"
import FormRadioButton from "../components/shared/formRadioButton"
import FormFieldDisableAutoComplete from "../components/shared/formFieldDisableAutoComplete"

// import * as Regex from "../common/regex"
import * as ErrorMessage from "../common/errorMessage"
import {
  missingInfoAlert,
  clearAllDataWarning,
  commonErrorAlert,
} from "../services/sweetalertService"
import * as API from "../services/httpService"
import * as CommonFunction from "../common/function"
import * as Regex from "../common/regex"
import { isValid, parse } from "date-fns"

const SupportingDocument = () => {
  const uiData = useSelector(state => state.uiData)
  const claimData = useSelector(state => state.claimData, shallowEqual)
  const dropdownData = useSelector(state => state.dropdownData, shallowEqual)
  const dispatch = useDispatch()
  const formRef = React.useRef()
  const { proofDocuments, claimUploadListModel, pageNumber, lockUploadDropdown } = uiData
  const { selectedBenefitsDetail } = claimData
  const previewsContainer = "BasicDocumentPreview"
  const [declarationShow, setDeclarationShow] = React.useState(false)

  function DropdownValueChange(documentId, documentDesc) {
    dispatch(selectDocument(documentId, documentDesc))
  }

  function checkDocumentStatus(documentId) {
    var hasExists = claimUploadListModel.filter(doc => {
      return doc.documentId === documentId
    })
    return hasExists.length > 0
  }

  const checkMandatoryUploadDocument = () => {
    let mandatoryList = []

    mandatoryList = proofDocuments.filter(x => x.mandatory)

    let isUploaded = false

    //reversed for loop, because splice function inside loop
    for (let i = mandatoryList.length - 1; i >= 0; --i) {
      isUploaded = false
      claimUploadListModel.forEach(
        (currentCoverageItem, currentCoverageKey) => {
          if (
            !isUploaded &&
            mandatoryList[i].documentId === currentCoverageItem.documentId
          ) {
            mandatoryList.splice(i, 1)
            isUploaded = true
          }
        }
      )
    }
    //At least one document uploaded
    return process.env.NODE_ENV == "development"
      ? true
      : mandatoryList.length == 0 && claimUploadListModel.length > 0
      ? true
      : false
  }

  const createLifeDocumentsList = () => {
    let lifeDocumentsArray = []

    proofDocuments.map((item, index) => {
      if (item.visible) {
        lifeDocumentsArray.push(
          <Row
            key={`list_${index}`}
            className="mt-3 paddingLeft15px paddingRight15 unsetMarginTopBottom"
          >
            <Col
              xs={12}
              md={12}
              className={
                "marginTop10px CheckBox documentUpload" +
                (checkDocumentStatus(item.documentId)
                  ? " documentSelectedText"
                  : "")
              }
            >
            {/* Important !!! Got partial Mandatory handling logic at PetLoss.js (petClaimDocumentsListUpdate()) */}
            {item.mandatory && Constants.medicalDocs.includes(item.documentId) && (
              <div> 
                <a 
                  target="_blank"
                  href="https://www.etiqa.com.sg/wp-content/uploads/2026/01/Medical-Report.pdf"
                  style={{ color: "red" }}
                >{item.description}</a>
                <p className="displayInline themeColor">- Required</p>
              </div>
            )}
            {item.mandatory && !Constants.medicalDocs.includes(item.documentId) && (
              <div>
                {item.description + " - " }
                <p className="displayInline themeColor">Required</p>
              </div>
            )}
            {!item.mandatory && (
              <div>
              {item.description + " (If any) " }
              </div>
            )}
            </Col>
          </Row>
        )
      }

      return null
    })
    return lifeDocumentsArray
  }

  const createLifeDocumentsDropdownList = () => {
    let lifeDocumentsDropdownArray = []
    proofDocuments.map((item, index) => {
      if (item.visible) {
        lifeDocumentsDropdownArray.push(
          <React.Fragment key={`dropdown_${index}`}>
            <Dropdown.Item
              onClick={DropdownValueChange.bind(
                this,
                item.documentId,
                item.description
              )}
              className={
                "dropdown-item DropdownItem AddTripDocumentClass " +
                (lockUploadDropdown ? "disabled" : "")
              }
            >
              {item.description}
            </Dropdown.Item>
            <Dropdown.Divider />
          </React.Fragment>
        )
      }
      return null
    })
    return lifeDocumentsDropdownArray
  }

  useEffect(() => {
    if (uiData.maxPageNumber < 3) {
      backMaxPage(uiData.maxPageNumber)
    } else dispatch(updateUiData("showLoading", false))
  }, [])


  return (
    <>
      <Formik
        initialValues={Object.assign(
          {},
          claimData["petClaimLossDetailsModel"]
        )}
        enableReinitialize={true}
        validateOnMount={true}
        innerRef={formRef}
        onSubmit={(values, actions) => {
          if (checkMandatoryUploadDocument()) {
            // dispatch(updateUiData("showLoading", true))

            let tempBenefitsDetail = selectedBenefitsDetail.length > 0 ? selectedBenefitsDetail : []
            if(tempBenefitsDetail.find(e => e["claimType"] == values.claimType) != undefined ? true : false) {
              //when submitted, just remove old one
              tempBenefitsDetail.splice(tempBenefitsDetail.indexOf(tempBenefitsDetail.find(e => e["claimType"] == values.claimType)),1)
            }
            //push filled data into selected list
            tempBenefitsDetail.push(claimData["petClaimLossDetailsModel"])
            dispatch(updateClaimData("selectedBenefitsDetail", tempBenefitsDetail))

            //clean existing form
            dispatch(resetPetLossDetail())
            //back to selection page
            CommonFunction.navigateToBenefits()
          } else {
            commonErrorAlert("Please provide supporting document.")
          }
        }}
      >
        {({ handleSubmit, isSubmitting, isValid, values, errors, dirty }) => (
          <FormikForm
            onSubmit={handleSubmit}
            className={pageNumber === 5 ? "" : "hide"}
          >
            <Row>
              <div className="title text-center">
                {uiData.claimFormTitle} eClaim
              </div>
              <div className={"containerBody paddingBottom0px boxShadowNone"}>
                <div className="formBlackNoteSection">
                  <i
                    className="fa fa-info-circle highlight-text marginRight5px"
                    aria-hidden="true"
                  ></i>
                  <span className="highlight-text">REMINDER:</span> The Insured
                  must promptly take all possible steps to trace or recover the
                  property lost.
                </div>
              </div>

              <div className={"containerBody marginTop20px"}>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="formContainer"
                >
                  <div className={"titleText"}>Upload Supporting Documents</div>
                </Col>

                <div className="formNoteSection">
                  <span className="highlight-text">PLEASE NOTE:</span> Etiqa’s
                  Representatives may contact you and request to present to
                  Etiqa the certified copy of the documents.
                </div>

                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="formContainer paddingTop0px"
                >
                  <div className="marginTop20px">
                    <FormLabel
                      text={"Supporting Documents Checklist: "}
                      className={"fieldTextBold fontSize18px"}
                    />
                  </div>
                  {createLifeDocumentsList()}
                  <br />
                  <Row className="paddingLeft15px paddingRight15">
                    <Col
                      xs={{ span: 12, offset: 0 }}
                      md={{ span: 12, offset: 0 }}
                      className="formContainer SupportingDocumentsUploadArea paddingTop0px"
                    >
                      <div>
                        <FormLabel
                          text={"Upload documents"}
                          className={"fieldTextBold"}
                        />
                        <div className={"textforinput marginTop10px"}>
                          <p className={""}>
                            Please note: Total file size should not exceed 10MB.
                          </p>
                        </div>

                        {uiData.exceededFileSizeLimit && (
                          <div className={"textforinput marginTop10px"}>
                            <p className={"colorRed"}>
                              Has exceeded the 10MB total file size limit.
                              Please reupload another file with smaller size.
                            </p>
                          </div>
                        )}
                        {pageNumber >= 5 && (
                          <>
                            <Row>
                              <Dropdown className="dropdown col-10 marginTop10px">
                                <Dropdown.Toggle
                                  id="dropdown-basic"
                                  className="btn btn-secondary dropdown-toggle DropdownHeader"
                                >
                                  {uiData.tempSelectedDocument.documentDesc}
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="dropdown-menu DropdownMenu">
                                  {createLifeDocumentsDropdownList()}
                                </Dropdown.Menu>
                              </Dropdown>

                              <Dropzone
                                uiData={uiData}
                                previewsContainer={previewsContainer}
                              />
                            </Row>

                            <Row>
                              <div
                                id={previewsContainer}
                                style={{
                                  width: "auto !important",
                                  border: "transparent !important",
                                  display: "contents",
                                }}
                                className={"dropzone "}
                              ></div>
                            </Row>
                          </>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Col>
              </div>
            </Row>
            <Row>
              <div className={"containerFooter marginTop3x"}>
                <div
                  onClick={() => {
                    clearAllDataWarning(
                      uiData.claimUploadListModel,
                      uiData.folderName,
                      dispatch
                    )
                  }}
                  className="btnBack fontWeightBold"
                  // disabled={!isValid || dirty}
                >
                  <b>Back</b>
                </div>
                <button
                  className={"btnSubmitForm fontWeightBold float-right "}
                  type="submit"
                  // disabled={isSubmitting}
                >
                  <b>Next</b>
                </button>
              </div>
            </Row>
            <HandleFormSubmit formRef={formRef} isSubmitting={isSubmitting} />
            <Declaration
              show={declarationShow}
              onHide={() => setDeclarationShow(false)}
            />
          </FormikForm>
        )}
      </Formik>
    </>
  )
}

const HandleFormSubmit = ({ formRef, isSubmitting }) => {
  React.useEffect(() => {
    if (isSubmitting) {
      formRef.current.validateForm().then(errors => {
        if (Object.entries(errors).length !== 0) {
          formRef.current.setSubmitting(false)
          console.log(errors);
        }
      })
    }
  }, [isSubmitting])
  return null
}
export default SupportingDocument
